export default function calculateMatrixAxis(count, size, spacing) {
    return (count * size) + spacing * (count - 1);
}
